"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs as MantineTabs, TabsList, TabsPanel, TabsTab, factory, useProps, } from "@mantine/core";
import "@mantine/core/styles/Tabs.layer.css";
import * as styles from "./Tabs.module.css";
const Tabs = factory(({ withUnderline = true, ...props }, ref) => {
    const modifiedProps = useProps("Tabs", {
        classNames: styles,
    }, props);
    return (_jsx(MantineTabs, { ...modifiedProps, "data-underline": withUnderline, ref: ref }));
});
Tabs.displayName = "Tabs";
TabsList.displayName = "TabsList";
TabsPanel.displayName = "TabsPanel";
TabsTab.displayName = "Tab";
Tabs.Tab = TabsTab;
Tabs.List = TabsList;
Tabs.Panel = TabsPanel;
export { Tabs, };
//# sourceMappingURL=Tabs.js.map